export default __webpack_public_path__ + "static/media/i025vp.90e77e56.webp";